import { render, staticRenderFns } from "./PageElementUpsertComponent.vue?vue&type=template&id=87346136&"
import script from "./PageElementUpsertComponent.vue?vue&type=script&lang=ts&"
export * from "./PageElementUpsertComponent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports